export const categories = ($http: HttpApi) => ({
  update: (params: HttpParams['body'] = {}) => $http.$patch('/builder/categories', { body: params }),
});
